import { STORAGE_KEYS } from './storageKeys'

const isBrowser = typeof window !== 'undefined'

const safeGetItem = (storage: Storage | null, key: string): string | null => {
  if (!storage) return null
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

const safeSetItem = (
  storage: Storage | null,
  key: string,
  value: string
): void => {
  if (!storage) return
  try {
    storage.setItem(key, value)
  } catch {
    // Ignore storage errors (e.g., quota or disabled storage)
  }
}

const safeRemoveItem = (storage: Storage | null, key: string): void => {
  if (!storage) return
  try {
    storage.removeItem(key)
  } catch {
    // Ignore storage errors
  }
}

const getRememberPreference = (): boolean => {
  if (!isBrowser) return true
  const stored = safeGetItem(localStorage, STORAGE_KEYS.REMEMBER_ME)
  if (stored === null) return true
  return stored === 'true'
}

const getPreferredStorage = (): Storage | null => {
  if (!isBrowser) return null
  return getRememberPreference() ? localStorage : sessionStorage
}

const getFallbackStorage = (): Storage | null => {
  if (!isBrowser) return null
  return getRememberPreference() ? sessionStorage : localStorage
}

export const getAuthStorageItem = (key: string): string | null => {
  const preferred = getPreferredStorage()
  const value = safeGetItem(preferred, key)
  if (value !== null) return value
  return safeGetItem(getFallbackStorage(), key)
}

export const setAuthStorageItem = (key: string, value: string): void => {
  const preferred = getPreferredStorage()
  if (!preferred) return
  safeSetItem(preferred, key, value)
  const other = preferred === localStorage ? sessionStorage : localStorage
  safeRemoveItem(other, key)
}

export const removeAuthStorageItem = (key: string): void => {
  if (!isBrowser) return
  safeRemoveItem(localStorage, key)
  safeRemoveItem(sessionStorage, key)
}

export const clearAuthStorageByPrefix = (prefix: string): void => {
  if (!isBrowser) return
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key)
      }
    })
  } catch {
    // Ignore storage errors
  }

  try {
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith(prefix)) {
        sessionStorage.removeItem(key)
      }
    })
  } catch {
    // Ignore storage errors
  }
}
